const Backbone = require('backbone'),
	formValidator = require('formValidator'),
	Captcha = require('common/captcha'),
	customValidationRules = require('customValidationRules');

module.exports = Backbone.View.extend({
	el: '.js-modal-sms-product',
	/**
	 * @returns {void}
	 */
	initialize: function() {
		this.$el.modal('show');
		this.initValidator();
		if (!window.recaptcha) {
			this.captchaView = new Captcha({
				el: '.js-text-form'
			});
		}
	},
	/**
	 * @returns {void}
	 */
	initValidator: function() {
		customValidationRules.add('phone-number');
		this.validator = formValidator.init({
			el: '.js-text-form',
			validate: {
				rules: {
					name: {
						required: true
					},
					phoneNumber: {
						required: true,
						'validate-phone-number': true
					}
				},
				messages: {
					name: {
						required: 'Please enter your name.'
					},
					phoneNumber: {
						required: 'Please enter your phone number.'
					}
				}
			}
		});
	}
});
